import { useState } from 'react';

import { TabsUI } from '../Interface';
import TaskListRespPersonTable from './TaskListRespPersonTable';

const TaskListTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'További felelősök',
      content: <TaskListRespPersonTable {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </div>
  );
};

export default TaskListTabs;
